<template>
  <div class="container h-100">
    <div class="content page-main">
      <div class="page-header">
        <div class="page-title">
          <h2>佣金开票详情</h2>
        </div>
        <!--        <div class="page-actions" v-if="formData.id">-->
        <!--          <el-button type="primary" @click="handleAudit" size="mini">审核</el-button>-->
        <!--          <el-button type="warning" @click="handleEdit" size="mini">编辑</el-button>-->
        <!--          <el-button type="danger" @click="handleDelete" size="mini">删除</el-button>-->
                  <el-button v-if="formData.status==='pending'" type="success" @click="handleSubmit" size="mini">提交审核</el-button>
                  <el-button v-if="formData.status==='rejected'" type="warning" @click="handleResubmit" size="mini">重新提交</el-button>
        <!--        </div>-->
      </div>

      <div class="page-content">
        <div v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
          <el-card class="box-card" v-if="formData.id">
            <div slot="header" class="clearfix">
              <span class="card-title">基本信息</span>
              <el-tag :type="statusType" size="small" style="float: right">
                {{ statusText }}
              </el-tag>
            </div>
            <el-form :model="formData" label-width="120px" size="mini">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="申请人：">
                    <span>{{ formData.applicant || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申请时间：">
                    <span>{{ dateFmt(formData.created_at) }}</span>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="乙方名称：">
                    <span>{{ formData.party_b_name || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户名称：">
                    <span>{{ formData.customer_name || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="发票抬头：">
                    <span>{{ formData.invoice_title || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="税号：">
                    <span>{{ formData.tax_number || '--' }}</span>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="发票类型：">
                    <span>{{ invoiceTypeText }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="发票金额：">
                    <span class="money-text">{{ moneyFormat(formData.apply_amount) }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="发票内容：">
                    <span>{{ formData.invoice_content || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电子邮箱：">
                    <span>{{ formData.recipient_email || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开票区间：">
                    <span>{{ dateFmt(formData.invoice_period_start) }}</span>
                    ~
                    <span>{{ dateFmt(formData.invoice_period_end) }}</span>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注：">
                    <span>{{ formData.remark || '--' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <el-card class="box-card" v-if="formData">
            <div slot="header" class="clearfix">
              <span class="card-title">红人信息</span>
            </div>

            <el-form :model="formData.artist_info" label-width="120px" size="mini">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开票来源：">
                    <span>{{ formData.invoice_source_text || '' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="红人昵称：">
                    <span v-if="formData.kol_nicknames">{{ formData.kol_nicknames.join('、') }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="平台：">
                    <span v-if="formData.platform">{{ formData.platform.join('、') }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="品牌：">
                    <span>{{ formData.brand || '--' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="店铺：">
                    <span>{{ formData.store || '--' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <el-card class="box-card" v-if="formData.attachment">
            <div slot="header" class="clearfix">
              <span class="card-title">附件信息</span>
            </div>

            <div class="attachment-section">
              <div v-if="formData.attachment.id">
                <div class="attachment-item">
                  <div class="attachment-name">
                    {{ formData.attachment.title }}
                    <el-link
                        style="margin-left: 10px; color: #ff3176"
                        @click="handleDownload(formData.attachment)"
                        icon="el-icon-download"
                        title="下载">
                      下载
                    </el-link>
                  </div>

                  <div v-if="formData.attachment.mime_type && formData.attachment.mime_type.indexOf('image') > -1"
                       class="attachment-preview">
                    <el-image
                        v-if="formData.attachment.url"
                        style="width: 100px; height: 100px; margin-top: 10px"
                        :src="formData.attachment.url"
                        :preview-src-list="[formData.attachment.url]">
                    </el-image>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="no-attachment">未上传附件</span>
              </div>
            </div>
          </el-card>

          <el-card class="box-card" v-if="['approved','rejected','reviewing'].indexOf(formData.status)>-1">
            <div slot="header" class="clearfix">
              <span class="card-title">审核信息</span>
            </div>

            <el-form label-width="120px" size="mini">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="提审时间：">
                    <span class="reject-reason">{{ formData.submit_time || '' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="审核时间：">
                    <span class="reject-reason">{{ formData.check_time || '' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="formData.checker_id">
                  <el-form-item label="审核人：">
                    <span class="reject-reason">{{ formData.checker_name || '' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="formData.unpass_reason">
                  <el-form-item label="拒绝原因：">
                    <span class="reject-reason">{{ formData.unpass_reason || '' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <el-card class="box-card" v-if="logList">
            <div slot="header" class="clearfix">
              <span class="card-title">日志</span>
            </div>
            <div v-if="logList">

            </div>
          </el-card>
          <br/>
          <!-- 审核对话框 -->
          <el-dialog title="审核佣金开票" :visible.sync="auditDialogVisible" width="500px">
            <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="100px">
              <el-form-item label="审核结果" prop="status">
                <el-radio-group v-model="auditForm.status">
                  <el-radio label="pass">通过</el-radio>
                  <el-radio label="reject">拒绝</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="拒绝原因" prop="unpass_reason" v-if="auditForm.status === 'reject'">
                <el-input type="textarea" :rows="4" v-model="auditForm.unpass_reason"
                          placeholder="请输入拒绝原因"></el-input>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="auditDialogVisible = false" size="mini">取消</el-button>
              <el-button type="primary" @click="handleAuditSubmit" :loading="auditLoading" size="mini">确定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCommissionInvoiceDetail,
  deleteCommissionInvoiceRecord,
  submitCommissionInvoiceRecord,
  reSubmitCommissionInvoiceRecord
} from "@/api/bill";
import {parseTime} from "@/utils";
import {downLoadFile} from "@/utils/upload";

export default {
  name: "CommissionInvoiceDetail",
  data() {
    return {
      id: null,
      formData: {},
      loading: false,
      auditDialogVisible: false,
      auditLoading: false,
      auditForm: {
        status: 'pass',
        unpass_reason: ''
      },
      auditRules: {
        unpass_reason: [
          {required: true, message: '请输入拒绝原因', trigger: 'blur'}
        ]
      },
      logList:[]
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    statusText() {
      const statusMap = {
        'pending': '待提交',
        'reviewing': '待审核',
        'approved': '已通过',
        'rejected': '已拒绝'
      };
      return statusMap[this.formData.status] || '--';
    },
    statusType() {
      const typeMap = {
        'pending': 'info',
        'reviewing': 'warning',
        'approved': 'success',
        'rejected': 'danger'
      };
      return typeMap[this.formData.status] || 'info';
    },
    invoiceTypeText() {
      const typeMap = {
        'spe_invoice': '电子专票',
        'common_invoice': '电子普票',
      };
      return typeMap[this.formData.invoice_type] || '--';
    },
    invoiceSourceText() {
      const typeMap = {
        'offline_invoice': '线上结佣线下开票',
      };
      return typeMap[this.formData.invoice_source] || '--';
    }
  },
  created() {
    this.id = this.$route.query.id || this.$route.params.id;
    if (this.id) {
      this.getDetail();
    } else {
      this.$message.error('缺少开票ID参数');
      this.$router.back();
    }
  },
  methods: {
    async getDetail() {
      this.loading = true;
      try {
        const res = await getCommissionInvoiceDetail(this.id);
        if (res.success) {
          this.formData = res.model || {};
        } else {
          this.$message.error(res.message || '获取详情失败');
        }
      } catch (error) {
        this.$message.error('获取详情失败');
      } finally {
        this.loading = false;
      }
    },

    moneyFormat(val) {
      return this.gFunc.numberFormat(val, 2, '.', ',');
    },

    dateFmt(dateStr) {
      if (dateStr) {
        return parseTime(dateStr, '{y}-{m}-{d}');
      }
      return '';
    },

    handleDownload(fileObj) {
      downLoadFile(fileObj.id, fileObj.title, () => {
        this.msgSuccess('下载成功');
      });
    },

    handleAudit() {
      this.auditForm = {
        status: 'pass',
        unpass_reason: ''
      };
      this.auditDialogVisible = true;
    },

    async handleAuditSubmit() {
      if (this.auditForm.status === 'reject') {
        this.$refs.auditForm.validate(async (valid) => {
          if (valid) {
            await this.submitAudit();
          }
        });
      } else {
        await this.submitAudit();
      }
    },

    async submitAudit() {
      this.auditLoading = true;
      try {
        // 这里需要调用审核API，但API中暂时没有佣金开票的审核接口
        // 可以根据实际需求添加相应的API调用
        this.$message.success('审核操作成功');
        this.auditDialogVisible = false;
        this.getDetail();
      } catch (error) {
        this.$message.error('审核操作失败');
      } finally {
        this.auditLoading = false;
      }
    },

    handleEdit() {
      this.$router.push({
        path: '/bill/commission/edit',
        query: {id: this.id}
      });
    },

    async handleDelete() {
      this.$confirm('确定要删除此佣金开票记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteCommissionInvoiceRecord(this.id);
          if (res.success) {
            this.$message.success('删除成功');
            this.$router.back();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        } catch (error) {
          this.$message.error('删除失败');
        }
      }).catch(() => {
      });
    },

    async handleSubmit() {
      this.$confirm('确定要提交审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await submitCommissionInvoiceRecord(this.id);
          if (res.success) {
            this.msgSuccess('提交成功');
            await this.getDetail();
          } else {
            this.$message.error(res.message || '提交失败');
          }
        } catch (error) {
          this.$message.error('提交失败');
        }
      }).catch(() => {
      });
    },

    async handleResubmit() {
      this.$confirm('确定要重新提交审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await reSubmitCommissionInvoiceRecord(this.id);
          if (res.success) {
            this.msgSuccess('重新提交成功');
            await this.getDetail();
          } else {
            this.$message.error(res.message || '重新提交失败');
          }
        } catch (error) {
          this.$message.error('重新提交失败');
        }
      }).catch(() => {
      });
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 20px;
}

.page-title h2 {
  margin: 0;
  color: #303133;
}

.page-actions {
  display: flex;
  gap: 10px;
}

.box-card {
  margin-bottom: 20px;
}

.card-title {
  font-weight: bold;
  color: #303133;
}

.money-text {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.1em;
  font-weight: bold;
  color: #ff3133;
}

.attachment-section {
  padding: 10px 40px;

}

.attachment-item {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #f5f7fa;
  gap: 10px;

}

.attachment-name {
  flex: 2;
  color: #606266;
}

.attachment-preview {
  margin-top: 10px;
}

.no-attachment {
  color: #909399;
  font-style: italic;
}

.reject-reason {
  color: #f56c6c;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
